// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CtbX","toggleWrap":"styles_toggleWrap__1GzbY","content":"styles_content__12rY7","selectAreaCode":"styles_selectAreaCode__1Iygr"};